
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_1cwcy_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_1cwcy_1",
  "root": "awsui_root_mgja0_1cwcy_120",
  "focus-lock": "awsui_focus-lock_mgja0_1cwcy_156",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_1cwcy_160",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_1cwcy_164",
  "calendar-container": "awsui_calendar-container_mgja0_1cwcy_168",
  "one-grid": "awsui_one-grid_mgja0_1cwcy_171",
  "calendar-header": "awsui_calendar-header_mgja0_1cwcy_175",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_1cwcy_181",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_1cwcy_181",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_1cwcy_202",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_1cwcy_205",
  "first-grid": "awsui_first-grid_mgja0_1cwcy_209",
  "second-grid": "awsui_second-grid_mgja0_1cwcy_210",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_1cwcy_214",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_1cwcy_220",
  "footer": "awsui_footer_mgja0_1cwcy_227",
  "has-clear-button": "awsui_has-clear-button_mgja0_1cwcy_234",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_1cwcy_241",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_1cwcy_248",
  "label": "awsui_label_mgja0_1cwcy_253",
  "label-enabled": "awsui_label-enabled_mgja0_1cwcy_258",
  "label-text": "awsui_label-text_mgja0_1cwcy_262",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_1cwcy_267",
  "mode-switch": "awsui_mode-switch_mgja0_1cwcy_271",
  "dropdown": "awsui_dropdown_mgja0_1cwcy_275",
  "dropdown-content": "awsui_dropdown-content_mgja0_1cwcy_291",
  "start-date-input": "awsui_start-date-input_mgja0_1cwcy_300",
  "start-time-input": "awsui_start-time-input_mgja0_1cwcy_301",
  "end-date-input": "awsui_end-date-input_mgja0_1cwcy_302",
  "end-time-input": "awsui_end-time-input_mgja0_1cwcy_303",
  "validation-section": "awsui_validation-section_mgja0_1cwcy_307",
  "validation-error": "awsui_validation-error_mgja0_1cwcy_311",
  "clear-button": "awsui_clear-button_mgja0_1cwcy_315",
  "apply-button": "awsui_apply-button_mgja0_1cwcy_319",
  "cancel-button": "awsui_cancel-button_mgja0_1cwcy_323",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_1cwcy_327"
};
  